import {
	LoginContainer,
	SignUpContainer,
	OTPContainer,
	ForgetPasswordContainer,
	ResetPasswordContainer,
	OnboardingContainerOne,
	OnboardingContainerTwo,
	PaymentLinkCheckoutContainer,
	BookingLinkDetailsContainer,
	FxTransferContainer,
} from '../containers';

import PasswordChangeSuccess from '../pages/ResetPassword/PasswordChangeSuccess';
import AlmostThere3 from '../pages/Onboarding/AlmostThere3';
import Error404 from '../pages/Error/Error404';
import constant from '../utils/constant';
import { AccountInReview } from '../pages';

const openRoutes = [
	{
		path: constant.Routes.Login,
		element: <LoginContainer />,
	},

	{
		path: constant.Routes.SignUp,
		element: <SignUpContainer />,
	},
	{
		path: constant.Routes.ForgetPassword,
		element: <ForgetPasswordContainer />,
	},

	{
		path: constant.Routes.Otp,
		element: <OTPContainer />,
	},

	{
		path: constant.Routes.ResetPassword,
		element: <ResetPasswordContainer />,
	},
	{
		path: constant.Routes.ResetPasswordChangeSuccess,
		element: <PasswordChangeSuccess />,
	},
	{
		path: constant.Routes.OnboardingStageOne,
		element: <OnboardingContainerOne />,
	},

	{
		path: constant.Routes.OnboardingStageTwo,
		element: <OnboardingContainerTwo />,
	},

	{
		path: constant.Routes.AlmostThereThree,
		element: <AlmostThere3 />,
	},
	{
		path: constant.Routes.Error404,
		element: <Error404 />,
	},
	{
		path: constant.Routes.PaymentLinkCheckout,
		element: <PaymentLinkCheckoutContainer />,
	},
	{
		path: constant.Routes.AccountInReview,
		element: <AccountInReview />,
	},
	{
		path: constant.Routes.MakeBookings,
		element: <BookingLinkDetailsContainer />,
	},
	{
		path: constant.Routes.FxTransferCheckout,
		element: <FxTransferContainer />,
	},
];

export default openRoutes;
